import LocalStorage from '../data/local-storage';
import { getAvatarUrl } from '../utils/helpers';

class AuthService {
  constructor() {
    this.isAuthenticated = false;
    this.user = {};
    this.token = null;
    this.pushSubscription = null;
  }

  load() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    if (token && userData) {
      this.isAuthenticated = true;
      this.user = JSON.parse(userData);
      this.token = token;
      this.pushSubscription = LocalStorage.getUserSpecificObject(
        'heliaedu_user_push_subscription',
        this.user.id
      );
    } else {
      this.isAuthenticated = false;
      this.user = {};
      this.token = null;
      this.pushSubscription = null;
    }
  }

  setAuthState(isAuth, user = {}, token = null) {
    this.isAuthenticated = isAuth;
    this.user = user;
    this.token = token;
    if (isAuth) {
      LocalStorage.setItem('heliaedu_token', token);
      LocalStorage.setObject('heliaedu_user', user);
      if (this.pushSubscription) {
        LocalStorage.setUserSpecificObject(
          'heliaedu_user_push_subscription',
          user.id,
          this.pushSubscription
        );
      }
    } else {
      LocalStorage.removeItem('heliaedu_token');
      LocalStorage.removeItem('heliaedu_user');
      if (this.pushSubscription) {
        LocalStorage.removeItem(
          LocalStorage.getUserSpecificKey(
            'heliaedu_user_push_subscription',
            this.user.id
          )
        );
      }
      this.pushSubscription = null;
    }
    this.updateAuthUI();
  }

  setPushSubscription(subscription) {
    this.pushSubscription = subscription;
    if (this.isAuthenticated && this.user.id) {
      if (subscription) {
        LocalStorage.setUserSpecificObject(
          'heliaedu_user_push_subscription',
          this.user.id,
          subscription
        );
      } else {
        LocalStorage.removeItem(
          LocalStorage.getUserSpecificKey(
            'heliaedu_user_push_subscription',
            this.user.id
          )
        );
      }
    }
  }

  getPushSubscription() {
    return this.pushSubscription;
  }

  updateAuthUI() {
    const isAuthenticated = this.isAuthenticated;
    const user = this.user;
    document.body.classList.toggle('guest-mode', !isAuthenticated);
    document.querySelectorAll('.guest-element').forEach(el => el.style.display = !isAuthenticated ? '' : 'none');
    document.querySelectorAll('.user-element').forEach(el => el.style.display = isAuthenticated ? '' : 'none');
    const userPhoto = document.querySelector('.user-photo');
    if (!userPhoto) return;
    const newUserPhoto = userPhoto.cloneNode(true);
    userPhoto.parentNode.replaceChild(newUserPhoto, userPhoto);
    if (!isAuthenticated) {
      newUserPhoto.setAttribute('href', '#/auth');
      newUserPhoto.setAttribute('data-text_tip', 'Masuk');
      newUserPhoto.classList.add('ubah-bentuk');
      newUserPhoto.innerHTML = `
        <span class="material-symbols-rounded">login</span>
        <span class="sr-only">Masuk</span>
      `;
    } else {
      newUserPhoto.setAttribute('href', '#/profile');
      newUserPhoto.setAttribute('data-text_tip', 'Profil');
      newUserPhoto.classList.remove('ubah-bentuk');
      newUserPhoto.innerHTML = `
        <img src="${getAvatarUrl(user.name || 'User')}" alt="Foto profil ${user.name}" width="32" height="32" loading="lazy">
        <span class="sr-only">Profil ${user.name}</span>
      `;
    }
  }
}

export default new AuthService();
